import React from "react";
import { Link } from "react-router-dom";
// import beach from "../assests/beach.jpg"
// import desert from "../assests/desert.jpg"
// import mountains from "../assests/mountains.jpg"
// import ocean from "../assests/ocean.jpg"
// import waterfall from "../assests/waterfall.jpg"
import "./Card.css";
export default function Card(props) {
  return (
    <>
      
        <div className="card col justify-content-center my-3">
        <Link to={props.path}>
          <div className="img-container">
            <img src={props.img} className="card-img-top" alt="..." />
          </div>
          </Link>
          <div className="card-body">
            <h6 className="card-title text-center">{props.title}</h6>
          </div>
        </div>
      
    </>
  );
}
